import $t from 'lib/trackingService';

const events = {
  init: 'ndp_playerInit',
  manualPlay: 'ndp_playerManualPlay',
  autoplayUnmuted: 'ndp_playerAutoplayUnmuted',
  autoplayMuted: 'ndp_playerAutoplayMuted',
  stick: 'ndp_playerStick',
  unstick: 'ndp_playerUnStick',
};

const track = (key, data = true, options = {}) => {
  if (typeof $t !== 'undefined') {
    $t('track', events[key], data, options);
  }
};

const VideoAnalytics = {
  initVideoAnalyticsBindings() {
    if (typeof $t !== 'undefined') {
      $t('register', Object.values(events));
    }
  },

  subscribeTsEventsToNdpPlayer(ndpPlayer, playerBrand) {
    const data = {
      playerObj: ndpPlayer,
      brand: playerBrand,
    };
    track('init', data);
  },

  trackVideoManualPlay() {
    track('manualPlay');
  },

  trackVideoAutoplayUnmuted() {
    track('autoplayUnmuted');
  },

  trackVideoAutoplayMuted() {
    track('autoplayMuted');
  },

  trackVideoStick() {
    track('stick');
  },

  trackVideoUnstick() {
    track('unstick');
  },
};

export default VideoAnalytics;
